export default {"src":"/_next/static/media/dot.5bd97f52.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};